import { FC, ReactNode } from "react";
import { Menu } from "antd";
import { clsx } from "clsx";
import classes from "./SectionMenu.module.less";

export interface SectionMenuItem {
    key: string;
    label: ReactNode;
}

export interface SectionMenuProps {
    /** The sections, in order. */
    items: SectionMenuItem[];
    /** The small uppercase heading above them, if any. */
    title?: ReactNode;
    selected: string;
    onSelect: (key: string) => void;
    className?: string;
}

/**
 * The left-hand list of a page's sections: one row per section, the current
 * one filled, no blue rule. Next to the section's content in a flex row.
 */
export const SectionMenu: FC<SectionMenuProps> = ({
    items,
    title,
    selected,
    onSelect,
    className,
}) => (
    <Menu
        className={clsx(classes.menu, className)}
        mode="inline"
        inlineIndent={12}
        selectedKeys={[selected]}
        onSelect={({ key }) => onSelect(key)}
        items={title ? [{ key: "sections", type: "group", label: title, children: items }] : items}
    />
);
